<template>
  <Layout>
    <PageHeader :title="title" :breadcrumbs="breadcrumbs"/>
    <form @submit="onSubmit">
      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <form class="outer-repeater">
                <div data-repeater-list="outer-group" class="outer">
                  <div data-repeater-item class="outer">

                    <div class="form-group row mb-4">
                      <label
                      for="email"
                      class="col-form-label col-lg-2">
                      {{ $t("users.form.email") }}
                      </label>
                      <div class="col-lg-10">
                        <b-form-input
                          id="email"
                          name="email"
                          type="email"
                          v-model="$v.user.email.$model"
                          class="form-control"
                          :state="validateField('email')"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback v-if="!$v.user.email.required">
                          {{ $t("validation.required") }}
                        </b-form-invalid-feedback>
                        <b-form-invalid-feedback v-if="!$v.user.email.email">
                          {{ $t("validation.email") }}
                        </b-form-invalid-feedback>
                      </div>
                    </div>

                    <div class="form-group row mb-4">
                      <label
                      for="password"
                      class="col-form-label col-lg-2">
                      {{ $t("users.form.password") }}
                      </label>
                      <div class="col-lg-10">
                        <b-form-input
                          id="password"
                          name="password"
                          type="password"
                          v-model="$v.user.password.$model"
                          class="form-control"
                          :state="validateField('password')"
                        >
                        </b-form-input>
                        <password
                        class="user-create__password-meter"
                        v-model="$v.user.password.$model"
                        :strength-meter-only="true"
                        :secureLength="6"
                        />
                        <b-form-invalid-feedback v-if="!$v.user.password.required">
                          {{ $t("validation.required") }}
                        </b-form-invalid-feedback>
                        <b-form-invalid-feedback v-if="!$v.user.password.minLength">
                          {{ $t("validation.min-length", {length: 6}) }}
                        </b-form-invalid-feedback>
                      </div>
                    </div>

                    <div class="form-group row mb-4">
                      <label
                      for="password-repeat"
                      class="col-form-label col-lg-2">
                      {{ $t("users.form.password-repeat") }}
                      </label>
                      <div class="col-lg-10">
                        <b-form-input
                          id="password-repeat"
                          name="password-repeat"
                          type="password"
                          v-model="$v.user.passwordRepeat.$model"
                          class="form-control"
                          :state="validateField('passwordRepeat')"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback v-if="!$v.user.passwordRepeat.sameAsPassword">
                          {{ $t("validation.same-passwords") }}
                        </b-form-invalid-feedback>
                      </div>
                    </div>
            
                    <div class="form-group row mb-4">
                      <label
                      for="first-name"
                      class="col-form-label col-lg-2">
                      {{ $t("users.form.first-name") }}
                      </label>
                      <div class="col-lg-4 col-xs-10">
                        <b-form-input
                          id="first-name"
                          name="first-name"
                          type="text"
                          v-model="$v.user.firstName.$model"
                          class="form-control"
                          :state="validateField('firstName')"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback>
                          {{ $t("validation.required") }}
                        </b-form-invalid-feedback>
                      </div>
                      
                      <label
                      for="last-name"
                      class="col-form-label col-lg-2 text-lg-right">
                      {{ $t("users.form.last-name") }}
                      </label>
                      <div class="col-lg-4 col-xs-10">
                        <b-form-input
                          id="last-name"
                          name="last-name"
                          type="text"
                          v-model="$v.user.lastName.$model"
                          class="form-control"
                          :state="validateField('lastName')"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback>
                          {{ $t("validation.required") }}
                        </b-form-invalid-feedback>
                      </div>
                    </div>

                    <div class="form-group row mb-4">
                      <label
                      for="phone"
                      class="col-form-label col-lg-2">
                      {{ $t("users.form.telephone") }}
                      </label>
                      <div class="col-lg-10">
                        <b-form-input
                          id="phone"
                          name="phone"
                          type="text"
                          v-model="$v.user.telephone.$model"
                          class="form-control"
                          :state="validateField('telephone')"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback>
                          {{ $t("validation.required") }}
                        </b-form-invalid-feedback>
                      </div>
                    </div>

                    <div class="form-group row mb-4">
                      <label
                      for="address"
                      class="col-form-label col-lg-2">
                      {{ $t("users.form.address") }}
                      </label>
                      <div class="col-lg-10">
                        <input
                          id="address"
                          name="address"
                          type="text"
                          v-model="user.address"
                          class="form-control"
                        />
                      </div>
                    </div>

                    <div class="form-group row mb-4">
                      <label
                      for="zip"
                      class="col-form-label col-lg-2">
                      {{ $t("users.form.zip") }}
                      </label>
                      <div class="col-lg-4 col-xs-10">
                        <input
                          id="zip"
                          name="zip"
                          type="text"
                          v-model="user.zip"
                          class="form-control"
                        />
                      </div>
                      <label
                      for="city"
                      class="col-form-label col-lg-2 text-lg-right">
                      {{ $t("users.form.city") }}
                      </label>
                      <div class="col-lg-4 col-xs-10">
                        <input
                          id="city"
                          name="city"
                          type="text"
                          v-model="user.city"
                          class="form-control"
                        />
                      </div>
                    </div>
                    
                    <div class="form-group row mb-4">
                      <label
                      for="department"
                      class="col-form-label col-lg-2">
                      {{ $t("users.form.department") }}
                      </label>
                      <div class="col-lg-10">
                        <b-form-select
                          id="department"
                          name="department"
                          v-model="$v.user.departmentId.$model"
                          :options="allDepartments"
                          text-field="title"
                          value-field="id"
                          :state="validateField('departmentId')"
                        ></b-form-select>
                        <b-form-invalid-feedback>
                          {{ $t("validation.min-one") }}
                        </b-form-invalid-feedback>
                      </div>
                    </div>

                  </div>
                </div>
              </form>
              <div class="row">
                <div class="col-12">
                  <button type="submit" class="btn btn-primary m-2">
                    <i class="fa fa-user" aria-hidden="true"></i>
                   {{ $t("users.form.create-user-button") }}
                  </button>
                  <button @click="$router.go(-1)" type="button" class="btn btn-secondary m-2">
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                   {{ $t("go-back") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </Layout>
</template>

<script>
import i18n from "@/i18n";
import Multiselect from "vue-multiselect";
import Password from 'vue-password-strength-meter';
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import { userService } from "@/helpers/services/user/userService";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";


const page = {
    title: i18n.t("users.create.title"),
    meta: [{ name: "description", content: appConfig.description }]
};

const components = {
  Layout,
  PageHeader,
  Multiselect,
  Password,
};


export default {
  name: "UserCreate",
  page,
  components,
  data() {
    return {
      breadcrumbs: [
        {text: i18n.t('users.overview.title'), href: "/users"},
        {text: i18n.t('users.create.title'), active: true},
      ],
      user: {
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        passwordRepeat: "",
        telephone: "",
        departmentId: "",
        zip: null,
        city: null,
        address: null,
        isSupervisor: true, // every user is supervisor for now
      },
      title: i18n.t('users.create.title'),
      uploadTo: null,
      allDepartments: [],
      allPools: [],
    };
  },
  validations: {
    user: {
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
      passwordRepeat: {
        sameAsPassword: sameAs('password'),
      },
      telephone: {
        required,
      },
      departmentId: {
        required,
      },
    },
  },
  methods: {
    validateField(name) {
      const { $dirty, $error } = this.$v.user[name];
      return $dirty ? !$error : null;
    },
    onSubmit(e) {
      e.preventDefault();

      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      userService.addNewUser(this.user);
    },
  },
  created() {
    userService.fetchDepartments()
      .then(d => this.allDepartments = d);
    userService.fetchPools()
      .then(p => this.allPools = p);
  },
};
</script>

<style lang="scss" scoped>
  .user-create__password-meter {
    margin: 0px;
  }
</style>